export default "__VITE_ASSET__Ydnx_w8L__"